import Story from '../../entities/Story';

import NetAnalyticsParticularEventsRepository from '../../../data/repositories/writer/NetAnalyticsParticularEventsRepository';

import {sendDefaultCustomEvent} from '../../../presentation/helpers/analytics';

export default class StoryCreateEvent {
  public async create(story: Story) {
    try {
      const analyticsParticularEvent =
        await new NetAnalyticsParticularEventsRepository().create({
          analyticsParticularEventParams: {
            resourceType: 'story',
            actionName: 'create',
            resourceId: story.id,
          },
        });
      switch (analyticsParticularEvent.sameEventsCount) {
        case 1:
          sendDefaultCustomEvent({
            resourceType: 'first_story',
            resourceId: analyticsParticularEvent.userId,
            actionName: 'create',
          });
          break;
        case 2:
          sendDefaultCustomEvent({
            resourceType: 'second_story',
            resourceId: analyticsParticularEvent.userId,
            actionName: 'create',
          });
          break;
      }
      return analyticsParticularEvent.sameEventsCount;
    } catch (e) {
      return null;
    }
  }
}
